/**
 * 008-reporting-dashboards T023 (US4, FR-015). Columns for `Sales.tsx`'s rows, same
 * `useTanStackTable`/`MainTable` machinery as `../invoicing/gst-summary-columns.tsx` — plain
 * `ColumnDef[]`, nothing computed (constitution I).
 *
 * Every column has an accessor — the API's own figure read as a number where it is one — so the
 * toolbar's search matches the group name and a header click sorts the whole fetched set. Figures
 * right-align through `meta.align`, the one alignment rule `TableView` applies to every table.
 */
import type { ColumnDef } from "@tanstack/react-table";
import { money, salesQuantity, type SalesRow } from "../../lib/services/invoicing";

const figure = (value: number | string | null | undefined) => (value === null || value === undefined || value === "" ? undefined : Number(value));

export const salesColumns: ColumnDef<SalesRow>[] = [
  { id: "groupName", accessorFn: (row) => row.groupName || "", header: "Group", cell: ({ row }) => row.original.groupName || "—" },
  {
    id: "invoiceCount",
    accessorFn: (row) => figure(row.invoiceCount),
    sortUndefined: "last",
    header: "Invoices",
    meta: { align: "right" },
    cell: ({ row }) => salesQuantity(row.original.invoiceCount),
  },
  {
    id: "quantity",
    accessorFn: (row) => figure(row.quantity),
    sortUndefined: "last",
    header: "Quantity",
    meta: { align: "right" },
    cell: ({ row }) => salesQuantity(row.original.quantity),
  },
  {
    id: "taxableValue",
    accessorFn: (row) => figure(row.taxableValue),
    sortUndefined: "last",
    header: "Taxable value",
    meta: { align: "right" },
    cell: ({ row }) => money(row.original.taxableValue),
  },
  {
    id: "taxAmount",
    accessorFn: (row) => figure(row.taxAmount),
    sortUndefined: "last",
    header: "Tax",
    meta: { align: "right" },
    cell: ({ row }) => money(row.original.taxAmount),
  },
  {
    id: "lineTotal",
    accessorFn: (row) => figure(row.lineTotal),
    sortUndefined: "last",
    header: "Line total",
    meta: { align: "right" },
    cell: ({ row }) => <span className="font-semibold text-gray-900">{money(row.original.lineTotal)}</span>,
  },
];
